import React, { useState } from "react";
import { isEmpty } from "lodash";

import { Button } from "../../../components/Field";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import AsyncGet from "../../../components/AsyncGet";
import DialogBox from "../../../components/DialogBox";
import AsyncForm from "../../../components/AsyncForm";
import MarketingPreferencesList from "../../../components/DialogBox/MarketingPreferencesList";

import style from "./style.module.css";

export default function MarketingPreferences(props) {
    const {
        userProfile,
    } = props;

    const [popup, setPopup] = useState(false);
    const [callMailchimp, setCallMailChimp] = useState(true);

    return (
        <>
            <Spacer size="65" />
            <div className={`${style.colRow} ${style.sectionItem}`}>
                <div className={style.titleContent}>
                    <Title className="fontTeko" transform="uppercase" tag="h4">Marketing Preferences</Title>
                </div>
                <div className={style.formContent}>
                    <div className={style.cardItem}>
                        <div className={style.cardItemtBody}>
                            <AsyncGet
                                id="mailchimpuser"
                                url="/account/mailchimpuser"
                                permissionText="Mailchimpuser"
                                loadOnMount={callMailchimp}
                                showToastOnError={false}
                                render={({ data }) => {
                                    if (data) {
                                        if (isEmpty(data)) {
                                            return (
                                                <AsyncForm
                                                    id="update-mailchimpuser"
                                                    url="/account/update-mailchimpuser"
                                                    permissionText="Update Mailchimpuser"
                                                    type="update"
                                                    hasGetAction={false}
                                                    showToastOnSuccess={false}
                                                    onSave={() => {
                                                        setCallMailChimp(Date.now());
                                                    }}
                                                    render={({ fetching, handleSubmit, onSubmit }) => (
                                                        <Button
                                                            color="buttonPrimary"
                                                            onClick={handleSubmit(onSubmit)}
                                                            fetching={fetching}
                                                            label="Subscribe"
                                                        />
                                                    )}
                                                />
                                            )
                                        }
                                        else {
                                            return (
                                                <>
                                                    <Title
                                                        className="fontTeko"
                                                        transform="uppercase"
                                                        tag="h6"
                                                    >
                                                        You are CURRENTLY opted in FOR MARKETING PURPOSES
                                                    </Title>
                                                    <Spacer />
                                                    <Title
                                                        tag="p"
                                                    >
                                                        You are CURRENTLY opted in FOR MARKETING PURPOSES
                                                    </Title>
                                                    <Spacer />
                                                    <Button
                                                        onClick={() => setPopup(true)}
                                                        target="blank"
                                                        color="buttonPrimary"
                                                        label="UPDATE"
                                                    />
                                                </>
                                            )
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                    <Spacer size="65" />
                </div>
            </div>
            {
                popup === true && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({ closeDialog }) => (
                            <MarketingPreferencesList
                                closeDialog={closeDialog}
                                userProfile={userProfile}
                            />
                        )}
                    />
                )
            }
        </>
    )
}